<template>
  <div>
    <div class="pure-g">
      <div class="pure-u-1-2">
        <div class="nav-chevron" @click="backwardChevronClickHandler">
          <FaiLayers>
            <Fai :icon="['far', 'circle']" class="circle" :class="backClassObj"/>
            <Fai v-if="backButtonLoading" :icon="['far', 'circle-notch']" class="circle" spin/>
            <Fai :icon="['fas', 'chevron-left']" transform="shrink-6 left-1" class="chevron"/>
          </FaiLayers>
        </div>
      </div>
      <div class="pure-u-1-2">
        <div class="nav-chevron" @click="forwardChevronClickHandler">
          <FaiLayers>
            <Fai :icon="['far', 'circle']" class="circle" :class="forwardClassObj"/>
            <Fai v-if="forwardButtonLoading" :icon="['far', 'circle-notch']" class="circle" spin/>
            <Fai :icon="['fas', 'chevron-right']" transform="shrink-6 right-1" class="chevron"/>
          </FaiLayers>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  import {
    GET_NEXT_STUDY_STEP_ROUTE,
    LOADING_STARTED,
    GET_IS_IN_PROGRESS_STUDY_UPDATING,
  } from '../../services/constants'

  const EVENT_NAME_TOUCHED = 'touched'
  export default {
    name: 'StudyNavigation',
    data() {
      return {
        forwardMode: true,
      }
    },
    props: {
      disableLoading: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      ...mapGetters([
        GET_NEXT_STUDY_STEP_ROUTE,
        GET_IS_IN_PROGRESS_STUDY_UPDATING,
      ]),
      backClassObj() {
        return {
          'loading': this.backButtonLoading
        }
      },
      forwardClassObj() {
        return {
          'loading': this.forwardButtonLoading
        }
      },
      isLucidCreateLoading() {
        return this.$store.state.dataModule.updateSelectedQualifications.loadingState === LOADING_STARTED
      },
      isAnythingLoading() {
        return this.isLucidCreateLoading || this[GET_IS_IN_PROGRESS_STUDY_UPDATING]
      },
      backButtonLoading() {
        return this.isAnythingLoading && !this.forwardMode && !this.disableLoading
      },
      forwardButtonLoading() {
        return this.isAnythingLoading && this.forwardMode && !this.disableLoading
      },
    },
    methods: {
      forwardChevronClickHandler(evt) {
        this.forwardMode = true
        this.emitTouched()
        this.callParentSubmitHandler()
      },
      backwardChevronClickHandler(evt) {
        this.forwardMode = false
        this.emitTouched()
        this.$router.back()
      },
      callParentSubmitHandler() {
        if(!this.isAnythingLoading) {
          const fName = 'handleSubmit'
          const h = this.$parent[fName]
          if (h && typeof h === 'function') {
            this.$parent[fName]()
          } else {
            throw new Error(`${this.$options.name}'s parent component ${this.$parent.$options.name} is missing ${fName} function`)
          }
        }
      },
      emitTouched() {
        this.$emit(EVENT_NAME_TOUCHED)
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .nav-chevron {
    display: flex;
    justify-content: center;
    font-size: 3em;
    transition: color 200ms;
    color: $cyan-blue-3;

    &:active {
      color: $red-2;
    }

    .chevron {
      color: $red-2;
    }

    .circle {
      &.loading {
        color: $red-2;
      }
    }
  }

</style>
